define('views/ModalView',['require','exports','module','views/BaseView','ldsh!../templates/modal'],function(require, exports, module) {
    'use strict';

    var BaseView = require('views/BaseView');

    var ModalView = BaseView.extend({
        template: require('ldsh!../templates/modal'),

        initialize: function() {

        },

        initEvents: function () {
            var self = this;

            this.$el.find('.modal__close').on('click', function() {
                if(self.options.onCancel){
                  self.options.onCancel();
                }
                self.$el.find('.modal').fadeOut(200);
            });

            this.$el.find('#cancelModal').on('click', function() {
                if(self.options.onCancel){
                  self.options.onCancel();
                }
                self.$el.find('.modal').fadeOut(200);
            });

            this.$el.find('#submitModal').on('click', function() {
                if(self.options.onSubmit){
                  self.options.onSubmit();
                }
                self.$el.find('.modal').fadeOut(200);
            });
        },

        insertBody: function () {
            if(this.options.body){
              this.$el.find('.modal__body').html(this.options.body);
            }
        },

        afterRender: function() {
            this.$el.i18n();
            this.initEvents();
            this.insertBody();
        },

        openModal: function () {
            this.$el.find('.modal').toggleClass('opened');
        },

        serialize: function() {
            return {
                modalExtraStyle: this.options.modalExtraStyle,
                modalExtraClass: this.options.modalExtraClass,
                title: this.options.title,
                description: this.options.description,
                body: !!this.options.body,
                submitText: this.options.submitText || 'PUBLIC.COMMONS.LBL_OK',
                cancelText: this.options.cancelText,
            };
        }
    });

    module.exports = ModalView;
});

